import React from 'react';
import { IConfigurableCar, IStockCar } from '../../../../interfaces/Car';
import { isBrandAP } from '../../../../constants/main';
import { useFeatureSwitchEnabled } from '@hooks/useFeatureSwitchEnabled';
import { FEATURES_LIST } from '../../../../context/featureSwitchApp';

export const renderCarName = ({ model, engine, bodyStyle, specPack, gearbox }: IConfigurableCar | IStockCar) => {
    const shouldIncludeBodyStyleDescription = useFeatureSwitchEnabled(
        FEATURES_LIST.FEATURE_SWITCH_SHOW_GR_BODY_STYLE_IN_CAR_TITLE
    );

    return (
        <div className="carInfoHeader">
            <div>
                <h2 className="car-title">
                    {!isBrandAP && (
                        <>
                            <span>
                                {model.title} {shouldIncludeBodyStyleDescription && bodyStyle.title}
                            </span>{' '}
                        </>
                    )}
                    <span className="title-specPack">{specPack.title}</span>
                </h2>
                <span className="title-engineInfo">
                    {engine.title} {gearbox.title}{' '}
                </span>
            </div>
        </div>
    );
};
